import debounce from 'lodash.debounce'

const DispatchSelectionChangedToSelectTextTooltipHookedAncestor = {
  mounted() {
    // Create a debounced handler function
    const handleSelectionChange = debounce(function (event) {
      const selection = window.getSelection()

      // Check if there's any selected text
      if (selection.toString().trim().length === 0) {
        return
      }

      // Get the selection range
      if (selection.rangeCount > 0) {
        const range = selection.getRangeAt(0)

        // Find the common ancestor element
        let targetElement = range.commonAncestorContainer

        // If it's a text node, get its parent element
        if (targetElement.nodeType === Node.TEXT_NODE) {
          targetElement = targetElement.parentElement
        }

        // Walk up the DOM tree to find the nearest element with `phx-hook="SelectTextTooltip"`
        while (targetElement && targetElement !== document.body) {
          if (
            targetElement.hasAttribute('phx-hook') &&
            targetElement.getAttribute('phx-hook') === 'SelectTextTooltip'
          ) {
            // Create and dispatch the custom event
            const customEvent = new CustomEvent('SelectTextTooltip_selectionchanged')

            targetElement.dispatchEvent(customEvent)
            break
          }
          targetElement = targetElement.parentElement
        }
      }
    }, 300) // 300ms debounce delay

    // Set up the global selection change handler
    document.addEventListener('selectionchange', handleSelectionChange)
  },
}

export default DispatchSelectionChangedToSelectTextTooltipHookedAncestor
